import React from 'react';
import { Field } from 'redux-form';
import { Radio, FlexRow } from 'components';
import { UserTypes } from 'constants/user';
import { requiredValidator } from 'helpers/fieldValidation';
import './PartnerCompanyType.scss';
const PartnerCompanyType = ({ onChange, split }) => {
    const versionType = split ? 'split' : 'stacked';
    const handleChange = () => onChange?.();
    return (React.createElement(FlexRow, { className: `partner-company-type--wrapper ${versionType}` },
        React.createElement(Field, { className: "partner-company-type--business-radio", component: Radio, id: "radio1", name: "company.companyType", onChange: handleChange, optionText: "I represent a business", subText: "e.g. Sole proprietorship, Corporation", type: "radio", validate: requiredValidator, value: UserTypes.BUSINESS }),
        React.createElement(Field, { className: "partner-company-type--individual-radio", component: Radio, id: "radio2", name: "company.companyType", onChange: handleChange, optionText: "I am an individual", subText: "e.g. Contractor or Freelancer", type: "radio", validate: requiredValidator, value: UserTypes.PERSONAL })));
};
export default PartnerCompanyType;
